<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label">{{ $t('mainProgram.nameKh') }} </label>
        <input ref="acp_name_native" v-model="model.acp_name_native" type="text" class="form-control kh-font"
          :class="{ 'is-invalid': errors.has('acp_name_native') }" :placeholder="$t('mainProgram.enternameKh')" />
        <div class="invalid-feedback" v-if="errors.has('acp_name_native')">
          {{ errors.first('acp_name_native') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('mainProgram.nameEn') }} <span class="text-danger">*</span>
        </label>
        <input v-model="model.acp_name_foreign" type="text" class="form-control"
          :class="{ 'is-invalid': errors.has('acp_name_foreign') }" :placeholder="$t('mainProgram.enternameEn')" />
        <div class="invalid-feedback" v-if="errors.has('acp_name_foreign')">
          {{ errors.first('acp_name_foreign') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('mainProgram.abbreviation') }}
        </label>
        <input v-model="model.acp_abbr" type="text" class="form-control" :class="{ 'is-invalid': errors.has('acp_abbr') }"
          :placeholder="$t('mainProgram.enterabbreviation')" />
        <div class="invalid-feedback" v-if="errors.has('acp_abbr')">
          {{ errors.first('acp_abbr') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button class="ml-2" color="primary" :disabled="saving" :waiting="saving" @click="update"
          v-if="editing == true">
          {{ $t('update') }}
        </ts-button>
        <ts-button class="ml-2" color="primary" :disabled="saving" :waiting="saving" @click="save" v-else>
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'main-program-create-form',
  props: ['edit'],
  data() {
    return {
      model: {
        acp_name_native: '',
        acp_name_foreign: '',
        acp_abbr: '',
        acp_id: '',
        scoring_cycle_list: []
      },
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  mounted() {
    this.$refs.acp_name_native.focus()
  },
  async created() {
    await this.setEdit()
  },
  methods: {
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'main-program' })
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'mainProgram/create',
          this.model
        )
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
        this.$refs.acp_name_native.focus()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'mainProgram/update',
          this.model
        )

        this.$toasted.success(response.message)
        this.$router.push({ name: 'main-program' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
        this.$refs.acp_name_native.focus()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      let {
        acp_name_native,
        acp_name_foreign,
        acp_id,
        acp_abbr
      } = this.edit

      this.model.acp_name_native = acp_name_native
      this.model.acp_name_foreign = acp_name_foreign
      this.model.acp_id = acp_id
      this.model.acp_abbr = acp_abbr

      this.editing = true
    },

    clearForm() {
      this.model.acp_name_native = ''
      this.model.acp_name_foreign = ''
      this.model.acp_abbr = ''
    }
  },
  watch: {
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
